import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-950 text-white py-12 px-6 border-t border-gray-900 relative z-10">
      <div className="max-w-7xl mx-auto text-center">
        <h4 className="text-2xl font-bold font-proyas tracking-wider mb-3 text-white">PROYAS</h4>
        <p className="text-gray-400 font-light tracking-wide text-sm mb-10 opacity-80">Building a bridge between care and opportunity</p>
        
        <div className="flex justify-center items-center gap-8 mb-10">
          <a href="mailto:contact@proyas.net" className="flex items-center gap-2 text-gray-400 hover:text-primary-400 transition-all duration-300 text-sm group">
            <div className="w-8 h-8 rounded-full bg-gray-900 border border-gray-800 group-hover:border-primary-500/50 group-hover:bg-primary-500/10 flex items-center justify-center transition-all duration-300">
              <svg className="w-4 h-4 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
            </div>
            <span className="font-light tracking-wide group-hover:text-primary-400 transition-colors">contact@proyas.net</span>
          </a>
          
          <a href="https://www.facebook.com/profile.php?id=61586633764841" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-primary-400 transition-all duration-300 text-sm group">
            <div className="w-8 h-8 rounded-full bg-gray-900 border border-gray-800 group-hover:border-primary-500/50 group-hover:bg-primary-500/10 flex items-center justify-center transition-all duration-300">
              <svg className="w-4 h-4 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
            </div>
            <span className="font-light tracking-wide group-hover:text-primary-400 transition-colors">Facebook</span>
          </a>
        </div>
        
        <div className="flex flex-col items-center gap-3">
          <p className="text-gray-500 text-[11px] uppercase tracking-[0.2em] font-medium hover:text-gray-300 transition-colors cursor-default">
            Developed by Abdullah Salim
          </p>
          <p className="text-gray-400 text-xs font-light">
            © 2026 PROYAS. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
